import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Subscription, Subject } from "rxjs";

import mensajes from "../../../assets/constantes/mensajes.json";
import { ModalType, ModalTitles } from "../../../shared/Constantes/modal.constantes";
import { Perfil } from "../../../shared/Entities/Perfil/perfil.entity";
import { Rol } from "../../../shared/Entities/Rol/rol.entity";
import { PerfilRepository } from "../../../shared/Repositories/perfil.repository";
import { RolesRepository } from "../../../shared/Repositories/roles.repository";
import { ModalService } from "../../../shared/Services/modal.service";

@Component({
  templateUrl: "./formulario.component.html",
  styleUrls: ["./formulario.component.scss"],
})
export class FormularioPerfilesComponent implements OnInit, OnDestroy {
  public subscriptions: Subscription[] = [];
  public perfil: Perfil;

  public title: string = "Creación de Perfil";
  public roles: Rol[];
  @ViewChild("formularioPerfiles", { static: true }) public formularioPerfiles: NgForm;

  public onClose: Subject<boolean>;

  constructor(
    private perfilesRepository: PerfilRepository,
    private rolesRepository: RolesRepository,
    private modalService: ModalService,
    public bsModalRef: BsModalRef
  ) {}

  public ngOnInit(): void {
    if (!this.perfil) this.perfil = new Perfil();
    this.onClose = new Subject();

    if (this.perfil.perfilRole && this.perfil.perfilRole.length > 0) {
      this.perfil.perfilRoleId = [];
      this.perfil.perfilRole.forEach((perfilRole) => {
        this.perfil.perfilRoleId.push(perfilRole.roleId);
      });
    }

    this.subscriptions.push(
      this.rolesRepository.getRoles().subscribe((roles) => {
        this.roles = roles;
      })
    );
  }

  public savePerfil(): void {
    if (this.formularioPerfiles.valid) {
      const perfilId = this.perfil.id || null;
      this.perfil.perfilRole = [];
      this.perfil.perfilRoleId.forEach((id) => {
        this.perfil.perfilRole.push({
          perfilId: perfilId,
          roleId: id,
        });
      });
      if (!this.perfil.id)
        this.perfilesRepository.savePerfil(this.perfil).subscribe(() => {
          this.onClose.next(true);
          this.bsModalRef.hide();

          this.modalService.showModalGeneral({
            title: ModalTitles.success,
            body: mensajes.formularioPerfiles.perfilCreado.body,
            type: ModalType.success,
          });
        });
      else
        this.perfilesRepository.updatePerfil(this.perfil).subscribe(() => {
          this.onClose.next(true);
          this.bsModalRef.hide();

          this.modalService.showModalGeneral({
            title: ModalTitles.success,
            body: mensajes.formularioPerfiles.perfilEditado.body,
            type: ModalType.success,
          });
        });
    }
  }

  public closeModal(): void {
    this.bsModalRef.hide();
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      if (!subscription.closed) subscription.unsubscribe();
    });
  }
}
